<template>
  <div class="case">
    <!-- 手机端内容 -->
    <div class="mobile_case_page">
      <img width="100%" src="../assets/img/mobile/case.jpg" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'case',
  data () {
    return {}
  },
  mounted () {
    document.querySelector('.mobile_case_page').style.height =
      window.innerHeight + 'px'
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1170px) {
  .pc_case_page {
    display: none;
  }
  .mobile_case_page {
    display: block;
    background: #0034b6;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/case.vue